import React from 'react';

import './styles.scss';

const FormError = ({ className = '', ...props }) => {
  return <div className={`FormError__message ${className}`} {...props} />;
};

export default FormError;
